// extracted by mini-css-extract-plugin
export default {"btn":"index_btn__DmQ46","text":"index_text__saOxl","error":"index_error__KQWoB"};